
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.28432 5.28434C5.66344 4.90522 6.27811 4.90522 6.65723 5.28434L11.9999 10.627L17.3426 5.28434C17.7217 4.90522 18.3364 4.90522 18.7155 5.28434C19.0947 5.66346 19.0947 6.27813 18.7155 6.65725L13.3728 11.9999L18.7156 17.3427C19.0948 17.7219 19.0948 18.3365 18.7156 18.7157C18.3365 19.0948 17.7218 19.0948 17.3427 18.7157L11.9999 13.3729L6.65713 18.7157C6.27801 19.0948 5.66334 19.0948 5.28422 18.7157C4.9051 18.3365 4.9051 17.7219 5.28422 17.3427L10.627 11.9999L5.28432 6.65725C4.9052 6.27813 4.9052 5.66346 5.28432 5.28434Z","fill":"#16171F"}})])
          )
        }
      }
    